/**
 * Wire names of the hook-kind client actions. A raw action's key is its Redux `type`, but a
 * hook action has none, so this enum is its one stable source: the lexicon entry and the
 * executor map both use it. The file has no imports, so it is safe on the server.
 */
export enum HookActionTypes {
  SEND_ENQUIRIES = 'sendEnquiries',
  SET_WEDDING_LOCATION = 'setWeddingLocation',
  CREATE_EVENT = 'createEvent',
  UPDATE_EVENT = 'updateEvent',
  DELETE_EVENT = 'deleteEvent',
  INVITE_GUESTS_TO_EVENT = 'inviteGuestsToEvent',
  UNINVITE_GUESTS_FROM_EVENT = 'uninviteGuestsFromEvent',
  INITIALISE_CHECKLIST = 'initialiseChecklist',
  ADD_TO_SHORTLIST = 'addToShortlist',
  MARK_SUPPLIER_BOOKED = 'markSupplierBooked',
  SET_APP_LANGUAGE = 'setAppLanguage',
}
